import React, { useEffect, useRef } from 'react'
import { CKEditor } from 'ckeditor4-react'

const CkItem = ({ formData, setFormData, keyT, title }) => {
    const editorRef = useRef(null);

    const handleEditorChange = (evt) => {
        setFormData(prevData => ({
            ...prevData,
            [keyT]: evt.editor.getData()
        }));
    };

    const handleEditorInstance = (editor) => {
        editorRef.current = editor;
    };

    useEffect(() => {
        if (editorRef.current && formData[keyT] !== undefined) {
            if (editorRef.current.getData() !== formData[keyT]) {
                editorRef.current.setData(formData[keyT] || '');
            }
        }
    }, [formData, keyT]);

    return (
        <div className="form-group mb-3">
            <label htmlFor={keyT} className="mb-2">{title}</label>
            <CKEditor
                key={`editor-${keyT}`}
                data={formData[keyT] || ''}
                onChange={handleEditorChange}
                onInstanceReady={(evt) => handleEditorInstance(evt.editor)}
                config={{
                    contentsCss: [
                        'body { background-color:rgb(222, 226, 233) !important; }'
                    ],
                    language: 'tr',
                    toolbar: [
                        { name: 'document', items: ['Source', '-', 'Save', 'NewPage', 'Preview', 'Print', '-', 'Templates'] },
                        { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
                        { name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'] },
                        { name: 'forms', items: ['Form', 'Checkbox', 'Radio', 'TextField', 'Textarea', 'Select', 'Button', 'ImageButton', 'HiddenField'] },
                        '/',
                        { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat'] },
                        { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language'] },
                        { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
                        { name: 'insert', items: ['Image', 'Flash', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'] },
                        '/',
                        { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
                        { name: 'colors', items: ['TextColor', 'BGColor'] },
                        { name: 'tools', items: ['Maximize', 'ShowBlocks'] }
                    ],
                    extraPlugins: 'colorbutton,colordialog',
                    height: 200,
                    placeholder: `${title}...`
                }}
            />
        </div>
    )
}

export default CkItem